import { useRef, useState } from "react";
import { ImagePlus } from "lucide-react";
import { api, formatApiError } from "../../../lib/api";
import { toast } from "sonner";
import { Button } from "../../../components/ui/button";

export const money = (v) => `£${Number(v || 0).toFixed(2)}`;

export const ImageField = ({ value, onChange, testId }) => {
    const fileRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    const upload = async (file) => {
        if (!file) return;
        setUploading(true);
        try {
            const data = new FormData();
            data.append("file", file);
            const res = await api.post("/admin/upload", data, { headers: { "Content-Type": "multipart/form-data" } });
            onChange(res.data.url);
            toast.success("Photo uploaded");
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail, "Upload failed"));
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="flex items-center gap-4">
            {value && <img src={value} alt="Current" className="h-20 w-20 rounded-lg object-cover bg-slate-100" data-testid={`${testId}-preview`} />}
            <input
                ref={fileRef}
                type="file"
                accept="image/jpeg,image/png,image/webp,image/gif"
                className="hidden"
                data-testid={`${testId}-file`}
                onChange={(e) => upload(e.target.files?.[0])}
            />
            <Button type="button" variant="outline" disabled={uploading} onClick={() => fileRef.current?.click()}
                data-testid={`${testId}-upload`} className="rounded-full">
                <ImagePlus className="h-4 w-4 mr-2" />
                {uploading ? "Uploading…" : value ? "Replace photo" : "Upload photo"}
            </Button>
            {value && (
                <Button type="button" variant="outline" onClick={() => onChange("")} data-testid={`${testId}-remove`}
                    className="rounded-full text-red-600 border-red-200 hover:bg-red-50">
                    Remove
                </Button>
            )}
        </div>
    );
};

export const StatusPill = ({ value }) => {
    const colors = {
        paid: "bg-green-100 text-green-700",
        pending: "bg-amber-100 text-amber-800",
        pay_at_shop: "bg-[#40E0D0]/30 text-[#0033A0]",
        failed: "bg-red-100 text-red-700",
        refunded: "bg-slate-200 text-slate-700",
        partially_refunded: "bg-slate-200 text-slate-700",
        Delivered: "bg-green-100 text-green-700",
        Cancelled: "bg-red-100 text-red-700",
        "Delivery Issue": "bg-amber-100 text-amber-800",
    };
    return (
        <span className={`inline-block rounded-full px-3 py-0.5 text-xs font-bold ${colors[value] || "bg-blue-100 text-[#0033A0]"}`}>
            {value === "pay_at_shop" ? "pay at shop" : value}
        </span>
    );
};
